// extracted by mini-css-extract-plugin
export default {"groupHeading":"SelectAsyncPaginate_groupHeading__2pi+E","groupWrapper":"SelectAsyncPaginate_groupWrapper__kLsgZ"};